import { render, staticRenderFns } from "./SampleApplyTestPackage.vue?vue&type=template&id=2d1a81a6"
import script from "./SampleApplyTestPackage.vue?vue&type=script&lang=js"
export * from "./SampleApplyTestPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports